import { render, staticRenderFns } from "./PaymentTab.vue?vue&type=template&id=5aa1489c"
import script from "../../services/teacher/payment-tab.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/payment-tab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports